// extracted by mini-css-extract-plugin
export default {"mCard":"rE-z","image":"sE-z","imageNoBackground":"tE-z","imageHasCategory":"uE-z","fullWidth":"vE-z"};